import type { UserType } from '@/types'

const displayNames: Record<UserType, string> = {
  'Super Admin': 'Super Admin',
  Admin: 'Admin',
  User: 'Sales',
  Marketing: 'Marketing',
  Orders: 'Orders',
  Quotes: 'Quotes',
  Support: 'Support',
  RFP: 'RFP',
  Employee: 'Employee (HR only)',
  BDR: 'BDR',
  Training: 'Training (worklist only)',
}

export function getUserTypeDisplayName(type: UserType | string): string {
  return displayNames[type as UserType] || type
}
